// extracted by mini-css-extract-plugin
export default {"scannerContainer":"RuntimePage_scannerContainer__n5-kK","logo":"RuntimePage_logo__uhAnS","timer":"RuntimePage_timer__BnVqN","shine":"RuntimePage_shine__Q6Yk2"};